type SanitizeFunction<T> = (value: T) => T;

export type Sanitizers<T> = SanitizeFunction<T> | SanitizeFunction<T>[];

/**
 * Use this function to santize a input value with a single or a chain of sanitizers
 **/
export default <T>(value: T, sanitizers?: Sanitizers<T>) => {
  // Skip sanitize when no options are used
  if (!sanitizers) {
    return value;
  }

  // Change function to array of functions
  if (typeof sanitizers === "function") {
    sanitizers = [sanitizers];
  }

  // Check if santize is an array
  if (Array.isArray(sanitizers)) {
    let result = value;
    for (const sanitizer of sanitizers) {
      // Execute the sanitizers in a chain
      if (typeof sanitizer === "function") {
        result = sanitizer(result);
      }
    }

    return result;
  }

  // If the santizer is used wrong we return the default value
  return value;
};
